import dayjs from 'dayjs';

import type { Channel, RewardStatus, TargetType } from './types';

export const ATTRIBUTION_DAYS = 7;
export const PAYOUT_DAY = 20;

export const AD_NOTICE =
  '이 글의 추천 링크를 통해 기부하면 작성자에게 웰로 파트너스 수익이 지급될 수 있습니다.';

export const REWARD_STATUS_BADGE: Record<RewardStatus, string> = {
  SCHEDULED: 'bg-B-25 text-B-500',
  HELD: 'bg-O-50 text-O-550',
  PAID: 'bg-M-25 text-M-400',
  RECLAIMED: 'bg-R-50 text-R-550',
  CANCELED: 'bg-Gray-200 text-Gray-600 xl:text-Gray-700',
};

export const REWARD_STATUS_LABEL: Record<RewardStatus, string> = {
  SCHEDULED: '예정',
  HELD: '보류',
  PAID: '지급완료',
  RECLAIMED: '회수',
  CANCELED: '취소',
};

export const CHANNEL_LABEL: Record<Channel, string> = {
  NAVER_BLOG: '네이버 블로그',
  INSTAGRAM: '인스타그램',
  YOUTUBE: '유튜브',
  PERSONAL_BLOG: '개인블로그',
  ETC: '기타',
};

export const TARGET_TYPE_LABEL: Record<TargetType, string> = {
  PAGE: '페이지',
  MONTHLY_EVENT: '월간 이벤트',
  REGION: '특정 지역',
  GIFT_PRODUCT: '특정 답례품',
};

export const toOptions = <Key extends string>(labels: Record<Key, string>) =>
  (Object.entries(labels) as [Key, string][]).map(([value, label]) => ({
    label,
    value,
  }));

export const formatWon = (value: number) =>
  `${value.toLocaleString('ko-KR')}원`;

export const formatMonthDay = (value: string) => dayjs(value).format('MM.DD');

export const PARTNERS_LINK_FORM_ID = 'partners-link-form';
